import { ProductFormProductPackaging } from "../../../ProductForm.types";
import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";
import { PackagingAccordion } from "./PackagingLine/PackagingAccordion";

type PackagingBoxProps = {
    packagings: ProductFormProductPackaging[];
    setProductPackagings: (newPackagings: ProductFormProductPackaging[]) => void;
};
export const PackagingBox = (props: PackagingBoxProps) => {
    const { packagings, setProductPackagings } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Fragment>
            <Box
                style={{
                    height: theme.spacing(6),
                    border: `1px solid rgb(231, 230, 228)`,

                    borderRadius: theme.spacing(1),
                    boxShadow: `0px 2px 8px 0px ${theme.custom.grey[500]}}}`,
                    backgroundColor: "#FEFCFB",

                    display: "grid",
                    gridTemplateColumns: "auto 200px 200px",
                }}
            >
                <Box
                    sx={{
                        gridColumn: "1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        paddingLeft: theme.spacing(2.5),
                    }}
                >
                    <Typography variant="body">{t("packagings.name")}</Typography>
                </Box>
                <Box
                    sx={{
                        gridColumn: "2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        paddingLeft: "20px",
                    }}
                >
                    <Typography variant="body">{t("packagings.form.quantity", "Quantity / Weight (g)")}</Typography>
                </Box>
            </Box>
            <PackagingAccordion packagings={packagings} setProductPackagings={setProductPackagings} />
        </Fragment>
    );
};
